<template>
  <header
    :class="
      `w-full ${
        this.$route.name === 'Home' ? 'bg-gray-200 mb-5' : 'bg-gray-200 mb-5'
      } fixed top-0 left-0 z-50 px-4 sm:px-8 lg:px-16 xl:px-40 2xl:px-64 py-2 ${
        isUserScrolling ? ' bg-white xl:py-2 shadow-md ' : 'xl:py-2'
      }`
    "
    id="navbar"
  >
    <Nav :loggedIn="loggedIn" />
  </header>
</template>

<script>
import Nav from "./Nav";
export default {
  props: ["loggedIn"],
  components: {
    Nav,
  },
  data() {
    return {
      isUserScrolling: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 10) {
        this.isUserScrolling = window.scrollY > 10;
      } else {
        this.isUserScrolling = false;
      }
    },
  },
};
</script>

<style scoped>
#navbar {
  transition: all 0.2s ease-in-out;
}
</style>
